import React from 'react';

const Services = () => {
  return (
    <section
      id="services-link"
      class="services section"
      style={{ fontFamily: 'Poppins, sans-serif' }}
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-title">
              <h2>We Offer Different Services</h2>
              <img src="img/section-img.png" alt="#" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6 col-12">
            <div class="single-service">
              <img src="img/services/01.png" alt="#" />
              <h4>Prepaid Recharge</h4>
              <p>
                We offer quick and convenient prepaid recharge solutions for
                mobile phones, helping customers stay connected without any
                hassle. Our platform supports a wide range of operators,
                ensuring seamless top-ups anytime, anywhere.
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <div class="single-service">
              <img src="img/services/02.png" alt="#" />
              <h4>DTH Recharge</h4>
              <p>
                With our DTH recharge service, customers can easily recharge
                their Direct-to-Home (DTH) connections, ensuring uninterrupted
                entertainment. Our fast and secure platform supports multiple
                DTH service providers.
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <div class="single-service">
              <img src="img/services/03.png" alt="#" />
              <h4>Bill Payment</h4>
              <p>
                Our utility bill payment service simplifies the process of
                paying bills for electricity, water, gas, and more. With a few
                clicks, customers can settle their monthly bills quickly,
                securely, and on time.
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <div class="single-service">
              <img src="img/services/04.png" alt="#" />
              <h4>DMT</h4>
              <p>
                The Domestic Money Transfer (DMT) service is a significant
                market in India, which has gained even more momentum with the
                recent rise in digital transactions
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <div class="single-service">
              <img src="img/services/05.png" alt="#" />
              <h4>AEPS</h4>
              <p>
                The Aadhaar Enabled Payment System (AEPS) is a payment platform
                that leverages the Unique Identification Number, enabling
                Aadhaar cardholders to seamlessly carry out financial
                transactions.
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <div class="single-service">
              <img src="img/services/06.png" alt="#" />
              <h4>Pancard</h4>
              <p>
                We support PAN card services through UTI. We invite partners to
                become PAN Service Agents (PSA).
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <div class="single-service">
              <img src="img/services/07.png" alt="#" />
              <h4>White Label Account</h4>
              <p>
                Our white label account service allows businesses to offer
                recharge and payment solutions under their own brand. This
                customizable solution helps businesses enhance their services
                while maintaining a professional and personalized customer
                experience.
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <div class="single-service">
              <img src="img/services/08.png" alt="#" />
              <h4>B2B Software (Admin)</h4>
              <p>
                Our B2B admin software provides businesses with an efficient
                platform to manage recharge operations, track transactions, and
                handle customer queries. It empowers business owners with
                real-time reporting and streamlined management tools for
                improved performance.
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <div class="single-service">
              <img src="img/services/09.png" alt="#" />
              <h4>Software Development</h4>
              <p>
                We specialize in custom software development, creating tailored
                solutions that meet the unique needs of your business. From web
                and mobile applications to complex enterprise systems, we
                deliver robust, scalable, and user-friendly software to help
                businesses grow.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
